import React from 'react';
import ReactDOM from 'react-dom/client';
import { setPersistence, browserLocalPersistence } from 'firebase/auth';
import App from './App';
import { auth, hasConfig } from './firebaseconfig';
import { isPlaceholderMapsKey } from './api/mapsConfig';
import './index.css';

async function loadGovOpsRuntimeConfig() {
  if (typeof window === 'undefined') return;
  try {
    const res = await fetch('/govops-config.json?v=2', { cache: 'no-store' });
    if (!res.ok) return;
    const cfg = await res.json();
    if (cfg.orgId) window.__GOVOPS_ORG_ID__ = String(cfg.orgId).trim();
    if (cfg.apiBase) window.GOVOPS_API_BASE = String(cfg.apiBase).replace(/\/+$/, '');
    const mapsKey = cfg.googleMapsApiKey ? String(cfg.googleMapsApiKey).trim() : '';
    if (mapsKey && !isPlaceholderMapsKey(mapsKey)) {
      window.__GOOGLE_MAPS_API_KEY__ = mapsKey;
    } else if (
      typeof window.__GOOGLE_MAPS_API_KEY__ !== 'undefined' &&
      isPlaceholderMapsKey(window.__GOOGLE_MAPS_API_KEY__)
    ) {
      delete window.__GOOGLE_MAPS_API_KEY__;
    }
  } catch (_) {
    /* optional runtime override */
  }
}

async function bootstrap() {
  await loadGovOpsRuntimeConfig();

  if (hasConfig && auth) {
    setPersistence(auth, browserLocalPersistence).catch((err) => {
      console.warn('Firebase Auth persistence:', err?.message || err);
    });
  }

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

bootstrap();
